export function getInlineParts(text) {
  return String(text).split(/(\*\*[^*\n]+\*\*)/g).filter(Boolean).map((part) =>
    part.startsWith("**") && part.endsWith("**")
      ? { text: part.slice(2, -2), strong: true } : { text: part, strong: false });
}

export function getReportParagraphs(text) {
  return String(text).split(/\n\s*\n/).filter((part) => part.trim()).map((part) => {
    const heading = part.match(/^(#{1,6})\s+(.+)$/);
    return heading ? { text: heading[2], heading: heading[1].length } : { text: part };
  });
}

export function isAmountColumn(heading) {
  return /amount|reimbursement/i.test(heading);
}

export function getDocumentBlocks(content) {
  const lines = String(content).split("\n");
  const blocks = [];
  let text = [];
  const cells = (line) => line.trim().slice(1, -1).split(/(?<!\\)\|/)
    .map((value) => value.trim().replace(/\\\|/g, "|"));
  const flush = () => {
    if (text.length) blocks.push({ text: text.join("\n") });
    text = [];
  };
  for (let index = 0; index < lines.length; index += 1) {
    if (/^\|.*\|$/.test(lines[index]) && /^\|(?:\s*:?-+:?\s*\|)+$/.test(lines[index + 1] || "")) {
      flush();
      const headers = cells(lines[index]);
      const rows = [];
      index += 2;
      while (index < lines.length && /^\|.*\|$/.test(lines[index]) && cells(lines[index]).length === headers.length) {
        rows.push(cells(lines[index]));
        index += 1;
      }
      index -= 1;
      blocks.push({ headers, rows });
    } else {
      text.push(lines[index]);
    }
  }
  flush();
  return blocks;
}
